// masked input

(function () {
    var inp = $('.inp_masked');
    if (!inp || !inp.length) return false;
    inp.each(function () {
        var $inp = $(this);
        var mask = $inp.data('mask');
        if (mask && mask.trim().length) {
            mask = mask.replace(/x/g, 9);
            $inp.mask(mask);
        }
    });
    inp.filter('[name="phone"]').mask("+9 (999) 999-99-99");
    inp.filter('[name="inn"]').mask("9999999999?99");
    inp.on('input.change', function () {
        $(this).focus().blur();
    });
})();

// text overflow

export function textoverflow(target) {
    var box = target && target.length ? target : $('.js-textoverflow');
    if (!box || !box.length) return false;
    box.dotdotdot({
        ellipsis: '... ',
        watch: true
    });
}

// scroll

export function scroll() {

    if (window.isMobile) {
        return false;
    }

    var scr = $('.js-scrollable');
    if (!scr || !scr.length) return false;

    scr.each(function() {
        var $scr = $(this);
        var config = {
            scrollbarPosition: 'outside',
            scrollInertia: 50,
            autoDraggerLength: true,
            autoHideScrollbar: true,
            mouseWheel:{ enable: true }
        };

        if ($scr.is('._mobile') && !window.isMobile) {
            return false;
        }
        if ($scr.is('._horiz')) {
            config.axis = 'x';
        }
        if ($scr.is('._vert')) {
            config.axis = 'y';
        }

        $scr.mCustomScrollbar(config);
    });
}

// tabs

export function tabs($tabbox) {
    var tabBox = $tabbox || $('.tab-box');
    if (!tabBox || !tabBox.length) return false;

    function slickUpdate($targettab) {
        // console.log('qq')
        let $sl = $targettab.find('.js-slider.slick-initialized');
        if ($sl.length && $sl.is(':visible')) {
            $.each($sl, (i, sl) => {
                console.log($(sl).data('sl'))
                $(sl).slick('setPosition');
            });
        }
    }
    function ddClose(targettab) {
        var dd = targettab.find('.dd-box.opened');
        if (dd) {
            var ddsl = dd.find('.dd-btn');
            ddsl.each(function(e) {
                ddBox(null, $(this));
            });
        }
    }

    function changetab(newtab) {
        var tabs, tab, tabbtns, tabchecks,
            $tab, $acttab, $tabbtn, $tabcheck;
        var $tab = $(newtab);
        if ($tab.is('.active')) return false;
        var $tab_data = $tab.data('tab');
        var tabs_data = $tab.closest('.tabs').data('tabs-data');
        var tabnav = $('.tab-nav[data-tabs-data="'+tabs_data+'"]');
        tabs = $('.tabs[data-tabs-data="'+tabs_data+'"]');
        tabbtns = tabnav.find('.tab-btn');
        tabchecks = tabbtns.find('.tab-btn__check');

        $tabbtn = tabbtns.filter('[data-tab="'+$tab_data+'"]');
        $tabcheck = $tabbtn.find(tabchecks);

        tabbtns.removeClass('active');
        $tabbtn.addClass('active');

        tabchecks.prop('checked', false).removeAttr('checked');
        $tabcheck.prop('checked', true).attr('checked', true);

        tab = tabs.children('.tab');
        $acttab = tab.filter('.active');
        tab.removeClass('active');
        $tab.addClass('active');
        tab.not($tab).not($acttab).hide();
        if ($acttab && $acttab.length) {
            $acttab.finish().fadeOut(300, function() {
                tab.removeClass('opened');
                ddClose($acttab);
                $tab.finish().fadeIn(300, function() {
                    $tab.addClass('opened');
                    $tab.closest(tabBox).trigger('tabs.changed', [$tab]);
                    slickUpdate($tab);
                });
            });
        } else {
            $tab.finish().fadeIn(300, function() {
                $tab.addClass('opened');
                $tab.closest(tabBox).trigger('tabs.changed', [$tab]);
                slickUpdate($tab);
            });
        }
    }

    tabBox.on('tabs.change', function(e, targettab) {
        var $tab = targettab;
        changetab($tab);
    });
    tabBox.on('tabs.changed', function(e, targettab) {
        $('#footer').trigger('foot.updateColor');
    });

    tabBox.each(function() {
        var cTabBox = $(this);
        var tabs_data = cTabBox.data('tabs-data');
        var tabNav = $('.tab-nav[data-tabs-data="'+tabs_data+'"]');
        var tabs = $('.tabs[data-tabs-data="'+tabs_data+'"]');
        var tab = tabs.children('.tab');
        var tabBtn = tabNav.find('.tab-btn');
        var tabcheck = tabBtn.find('.tab-btn__check');

        var actBtn = tabBtn.filter('.active');
        actBtn = actBtn.length ? actBtn : tabBtn.eq(0);
        var actTab = tab.filter('[data-tab="'+actBtn.data('tab')+'"]');
        actBtn.addClass('active')
            .find(tabcheck).prop('checked',true).attr('checked',true);
        changetab(actTab);
        tabs.addClass('_inited');

        tabBtn.click(function(e) {
            e.preventDefault();
            var $tabbtn = $(this);
            var tab_data = $tabbtn.data('tab');
            var $tab = tab.filter('[data-tab="'+tab_data+'"]');
            changetab($tab);
        });
    });
}
function opentab(e, $btn, tabname) {
    $btn = $($btn);
    if ($btn.is('a') || $btn.is('input[type="submit"]')) {
        e.preventDefault();
    }

    //	if ($btn.is('.tab-side-btn')) {
    //		var sidenav = $btn.closest('.tab-side-nav');
    //		var $btns = sidenav.find('.tab-side-btn');
    //		$btns.removeClass('active');
    //		if (!$btn.is('.tab-side-tomain')) {
    //			$btn.addClass('active');
    //		}
    //	}

    var $tabs = $btn.closest('.tab-box');
    var $tab = $tabs.find('.tab[tab="'+tabname+'"]');
    if ($tab && $tab.length) $tabs.trigger('tabs.change', [$tab]);
}

// dd-box

export function ddBox(e, closeOnMisclick, speed) {
    var ddbtn, data, ddsl;

    function open($ddsl, $btn, speed) {
        if ($ddsl.is('._mobile') && !window.isMobile) return false;
        speed = speed !== void(0) ? speed : 200;
        if ($btn && $btn.length) $btn.addClass('btn_active');
        $ddsl.addClass('sl_opened');
        $ddsl.trigger('ddbox.opening');
        $ddsl.slideDown(speed, function() {
            $ddsl.addClass('sl_active');
            $ddsl.trigger('ddbox.opened');
        });
    }
    function close($ddsl, $btn, speed) {
        if ($ddsl.is('._mobile') && !window.isMobile) return false;
        speed = speed !== void(0) ? speed : 200;
        if ($btn && $btn.length) $btn.removeClass('btn_active');
        $ddsl.removeClass('sl_opened');
        $ddsl.trigger('ddbox.closing');
        $ddsl.slideUp(speed, function() {
            $ddsl.removeClass('sl_active');
            $ddsl.trigger('ddbox.closed');
        });
    }

    if (e != null && e != undefined) {
        var $target = $(e.target);
        if ($target.is('a')
            || $target.is('[type="submit"]')
            || $target.is('button')) {
            e.preventDefault();
        }
        ddbtn = $target.is('.dd-btn') ? $target : $target.closest('.dd-btn');
        data = ddbtn.data('dd');
        ddsl = $('.dd-sl[data-dd="'+data+'"]');
        if (!ddsl || !ddsl.length) return false;
        speed = speed ? speed : 200;

        let multiSl = ddsl.length > 1;
        let $currBtn = ddbtn;
        $.each(ddsl, function (i, sl) {

            let $currSl = $(sl);
            if (multiSl) $currBtn = $currSl.is('._dd-default') ? ddbtn : null;
            if ($currSl.is('.sl_active')) {
                close($currSl, $currBtn, speed);
            } else {
                open($currSl, $currBtn, speed);
            }

        });

        function missclick(e) {
            if (ddsl.is('.sl_active')
                && !$(e.target).closest(ddsl).length
                && !$(e.target).closest(ddbtn).length) {
                close(ddsl, ddbtn, speed);
                $(document).off('click.dd', missclick);
            }
        }
        if (closeOnMisclick) {
            $(document).on('click.dd', missclick);
        }
    } else {
        ddsl = $('.dd-sl');
        if (!ddsl || !ddsl.length) return false;

        ddsl.each(function () {
            var $ddsl = $(this);
            data = $ddsl.data('dd');
            var $ddbtn = $('.dd-btn[data-dd="'+data+'"]');
            if ($ddsl.is('.sl_active') && $ddsl.is('._dd-default')) {
                open($ddsl, $ddbtn, 0);
            }

            let $currBtn = $ddbtn;
            $ddsl.on('ddbox.open', function (e) {
                let $currSl = $(this);
                if (!$currSl.is('._dd-default')) $currBtn = null;
                open($currSl, $currBtn);
            });
            $ddsl.on('ddbox.close', function (e) {
                let $currSl = $(this);
                if (!$currSl.is('._dd-default')) $currBtn = null;
                close($currSl, $currBtn);
            });
            $ddsl.on('ddbox.toggle', function (e) {
                let $currSl = $(this);
                if (!$currSl.is('._dd-default')) $currBtn = null;
                if ($currSl.is('.sl_active')) {
                    close($currSl, $currBtn);
                } else {
                    open($currSl, $currBtn);
                }
            });
        });
    }
}
window.ddBox = ddBox;

// slick slider

export function slickslider() {
    var slider = $('.js-slider');
    if (!slider || !slider.length) return false;

    slider.each(function() {
        var csl = $(this);
        var config = {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            focusOnSelect: false,
            speed: 300,
            useTransform: true,
            draggable: false,
            adaptiveHeight: false,
            fade: false
        };
        var csl_data = csl.data('sl');

        var btns = $('.js-slider__btn[data-sl="'+csl_data+'"]');
        if (btns && btns.length) {
            config.arrows = true;
            config.prevArrow = btns.filter('.btn_prev');
            config.nextArrow = btns.filter('.btn_next');
        }

        if (csl.is('[data-sl-show]')) {
            config.slidesToShow = +csl.data('sl-show');
        }
        if (csl.is('.slider_fade')) {
            config.fade = true;
        }
        if (csl.is('.slider_auto')) {
            var autoSpeedData = csl.data('auto-speed');
            var autospeed = 3000;
            if (autoSpeedData && autoSpeedData.length) {
                autospeed = +autoSpeedData;
            }
            config.infinite = true;
            config.autoplay = true;
            config.autoplaySpeed = autospeed;
        }
        if (csl.is('.slider_loop')) {
            config.infinite = true;
        }
        if (csl.is('.slider_vert')) {
            config.vertical = true;
        }

        var navfor_data = csl.data('navfor');
        var navby_data = csl.data('navby');
        if (navfor_data && navfor_data.length) {
            config.asNavFor = '.js-slider[data-navby="'+navfor_data+'"]';
        }
        if (navby_data && navby_data.length) {
            // config.arrows = false;
            config.focusOnSelect = true;
        }

        // counter
        if (csl_data && csl_data.length) {
            var cnter = $('.js-slider-counter[data-sl="'+csl_data+'"]');
            var cnterNum = cnter.find('.num');
            var cnterCount = cnter.find('.count');
            if (cnter && cnter.length) {
                csl.on('init', function(event, slick){
                    cnterNum.text(slick.currentSlide+1);
                    cnterCount.text(slick.$slides.length);
                });
                csl.on('afterChange', function(event, slick, currentSlide){
                    cnterNum.text(slick.currentSlide+1);
                    cnterCount.text(slick.$slides.length);
                });
            }
        }

        if (csl_data === 'photos' && csl.is('._simple')) {
            config.dots = true;
        }

        csl.data('_slickconfig', config);
        csl.slick(config);
        csl.on('beforeChange afterChange', function(event, slick, currentSlide, nextSlide) {
            event.stopPropagation();
        });
        // csl.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        //     config.prevArrow.add(config.nextArrow).removeClass('_disabled');
        //     if (btns && btns.length) {
        //         if (nextSlide === 0) {
        //             config.prevArrow.addClass('_disabled');
        //         } else if (nextSlide === slick.$slides.length - 1) {
        //             config.nextArrow.addClass('_disabled');
        //         }
        //     }
        // });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/snippets.js